module.exports = __webpack_public_path__ + "media/images/aranha-36428db38188b1f02878ac9f58741d9b.png";